import ReactHeap from 'reactjs-heap';

const initializeHeap = () => {
  const heapAppId = process.env.REACT_APP_APP_ID;
  ReactHeap.initialize(heapAppId);
};

export { initializeHeap };
